/**
 * JSON Schema for the main object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/MediaItemExtraId",
  type: "object",
  properties: {
    origin: { type: "string" },
    media_id: { type: "string" },
    module_id: { type: "string" },
    page_link: { type: "string" },
    list_name: {
      type: "string",
      enum: ["mystarzlist", "watchlist", "historylist"]
    }
  },
  required: ["origin", "media_id", "list_name"]
};
